import React, { lazy, Suspense, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Nav from "./components/Nav/Nav";
import ScrollToTop from "./ScrollToTop";
import Loading from "./components/Loading/Loading";

const Home = lazy(() => import("./pages/Home"));
const Register = lazy(() => import("./pages/Register"));
const Account = lazy(() => import("./pages/Account"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));

const Router = () => {
  const [activeLogin, setActiveLogin] = useState(false);
  const [selectedMenuMob, setSelectedMenuMob] = useState({ id: 1 });

  function RequireAuth({ children }) {
    const tokenCamp = localStorage.getItem("tokenCamp");
    let location = useLocation();

    if (!tokenCamp) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    return children;
  }
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Nav
          activeLogin={activeLogin}
          setActiveLogin={setActiveLogin}
          selectedMenuMob={selectedMenuMob}
          setSelectedMenuMob={setSelectedMenuMob}
        />
        <ScrollToTop />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Home activeLogin={activeLogin} setActiveLogin={setActiveLogin} />
            }
          />
          <Route
            exact
            path="/register"
            element={
              <Register
                activeLogin={activeLogin}
                setActiveLogin={setActiveLogin}
              />
            }
          />
          <Route
            exact
            path="/forgotpass"
            element={
              <ForgotPassword
                activeLogin={activeLogin}
                setActiveLogin={setActiveLogin}
              />
            }
          />
          <Route
            exact
            path="/account"
            element={
              <RequireAuth>
                <Account
                  selectedMenuMob={selectedMenuMob}
                  setSelectedMenuMob={setSelectedMenuMob}
                />
              </RequireAuth>
            }
          />
        </Routes>
        {/* <Footer /> */}
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
